import PropTypes from 'prop-types'

import CardRatingHeaderLeft from './CardRatingHeaderLeft.js'
import CardRatingHeaderRight from './CardRatingHeaderRight.js'

const CardRatingHeader = ({
  children,
  rating,
  reviewDate,
  reviewerName,
  showAvatar = false,
  showRating = true,
  actions
}) => {
  const hasReviewerName = Boolean(reviewerName)
  return (
    <div className="mt-CardRating-header">
      {hasReviewerName ? (
        <CardRatingHeaderLeft
          rating={rating}
          reviewerName={reviewerName}
          showAvatar={showAvatar}
          showRating={showRating}
        />
      ) : (
        children
      )}
      <CardRatingHeaderRight reviewDate={reviewDate} actions={actions} />
    </div>
  )
}

CardRatingHeader.displayName = 'CardRatingHeader'

CardRatingHeader.propTypes = {
  rating: PropTypes.number,
  reviewDate: PropTypes.string.isRequired,
  reviewerName: PropTypes.string.isRequired,
  showAvatar: PropTypes.bool,
  showRating: PropTypes.bool,
  actions: PropTypes.node,
  children: PropTypes.node
}

export default CardRatingHeader
